export default __webpack_public_path__ + "static/media/Om-Sarva-Mangal-Mangalye.de9f0a98.mp3";